import { TsDOM as q } from '@/scripts/core/TsDOM'
import { UcoastEl } from '@/scripts/core/UcoastEl'

export class ModelInfo extends UcoastEl {
    static htmlSelector = 'model-info'
    toggle: HTMLButtonElement
    constructor() {
        super()

        this.toggle = q.rs('.model-toggle', this)

        this.toggle.addEventListener('click', this.onToggleEvent.bind(this))
    }

    onToggleEvent(e: Event) {
        e.preventDefault()
        this.classList.toggle('active')
    } 
}
